import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { IMembersGoogleScholarCandidate } from "./routeType";

const { key, getPath } = getApi("members.googleScholar.candidate.post");

type IExtractedRouteType =
  IMembersGoogleScholarCandidate["candidateGoogleScholarDataSingleConfirm"];

export type IPostMemberGoogleScholarCandidate =
  IPickMutation<IExtractedRouteType>;

const postMemberGoogleScholarCandidate: Fetcher<
  IPostMemberGoogleScholarCandidate["response"],
  IPostMemberGoogleScholarCandidate["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberGoogleScholarCandidate = createQuery({
  queryKey: [key],
  fetcher: postMemberGoogleScholarCandidate,
});
